import React, { useEffect, useRef } from 'react';
import { StateResultsProvided } from 'react-instantsearch-core';
import { connectStateResults } from 'react-instantsearch-dom';
import { isEqual, pick } from 'lodash';

const hasUserChangedSearch = (
  a: StateResultsProvided['searchState'],
  b: StateResultsProvided['searchState'],
) => {
  const aCompare = pick(a, 'refinementList', 'menu', 'query');
  const bCompare = pick(b, 'refinementList', 'menu', 'query');

  return !isEqual(aCompare, bCompare);
};

// This component observes the user's search state, and scrolls to the top when they've made a change to their query/filters
export const ScrollTopOnSearchChangeConnected: React.FC<StateResultsProvided> = ({
  searchState,
}) => {
  const previousSearchState = useRef<StateResultsProvided['searchState'] | null>(null);
  useEffect(() => {
    if (!previousSearchState.current) {
      previousSearchState.current = searchState;
    } else {
      if (hasUserChangedSearch(previousSearchState.current, searchState)) {
        window.scrollTo({ top: 0 });
      }
      previousSearchState.current = searchState;
    }
  }, [searchState]);

  return null;
};

export const ScrollTopOnSearchChange = connectStateResults(ScrollTopOnSearchChangeConnected);
